<template>
  <div class='h-mml-xybox'>
    <p style='padding:0px;margin:0px;'><pre>{{msgContent()}}</pre></p>
  </div>
</template>

<script>
export default {
  name: 'ShowMsgContent',
  props: {
    resp: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    msgContent() {
      if(this.resp.datas !=undefined && this.resp.datas.length >0){
          if(this.resp.mo.moId =='107' || this.resp.mo.moId =='57'){
            let res='';
                 for(let i =0;i<this.resp.datas.length;i++){
                  res += this.resp.datas[i].Data[0].MessageContent+"\n";
                 }
                 return res ? res :'';
          }

       const data = this.resp.datas[this.resp.datas.length-1];
       const msg =  data.Data;
         return msg && msg[0] ? msg[0].MessageContent : '';
      }else{
         const msg = this.resp.data.Data;
         return msg && msg[0] ? msg[0].MessageContent : '';
      }

    }
  }
};
</script>

<style>

</style>